export default __webpack_public_path__ + "static/media/target.827ab785.jpg";